import React, { Fragment } from "react";
import Card from "../../components/card/Card";
import ModalMsg from "../../components/ModalMsg";
import AlberoStrutturaTopicsController from "./components/AlberoStrutturaTopicsController";
import ModalUploadElementi from "../../components/ModalUploadElementi";

export default function ConfTopicView({
                                          bottoniDx,
                                          show,
                                          setShow,
                                          modalMsg,
                                          loadingData,
                                          topicSel,
                                          treeData,
                                          showModalUploadTopics,
                                          setShowModalUploadTopics,
                                          updateDati,
                                          token,
                                          translate,
                                      }) {

    return (
        <Card
            icon={'fas fa-list'}
            title={'Topics'}
            bottoniDx={bottoniDx}
        >
            <ModalMsg
                show={show}
                handleClose={() => setShow(false)}
                testo={modalMsg}/>
            <ModalUploadElementi
                titolo={"Upload Topics"}
                endopoint={process.env.REACT_APP_API_ENDPOINT + `/api/sost/topics/template-import/`}
                show={showModalUploadTopics}
                translate={translate}
                token={token}
                handleClose={() => {
                    setShowModalUploadTopics(false);
                    updateDati();
                }}/>
            {
                !loadingData &&
                <AlberoStrutturaTopicsController
                    topicSel={topicSel}
                    treeData={treeData}
                />
            }
        </Card>
    );
}
